import getAppDeepLink from 'shared/util/app-deep-link'
import renderArttribution from './attribution'
import renderGif from './gif'
import css from './media.css'
import renderMoreGifs from './more-gifs'
import renderSearch from './search'

export default function ({ gif, giphyUrl, renditionFilename, trackingQueryString }, isWebpSupported) {
    const { is_sticker, url } = gif
    return `<div class="${css.container}">
            ${window.optimizeMediaLandingSearchBar ? renderSearch() : ''}
            ${renderArttribution(gif, giphyUrl, trackingQueryString)}
            <a class="${is_sticker ? css.sticker : css.gif}"
                href="${url}?${trackingQueryString}"
                onclick="trackEvent('Click', 'Image')">
                ${renderGif(gif, renditionFilename, isWebpSupported)}
            </a>
            ${renderMoreGifs(gif, giphyUrl, trackingQueryString)}
            ${
                global.isMobile
                    ? `<a class="${css.openInApp}" href="${getAppDeepLink(
                          url
                      )}" onclick="trackEvent('App Download Click')" target="_blank">Use our app</a>`
                    : ''
            }
        </div>`
}
